import $ from "jquery";
import { debounce } from "lodash";

const searchResultsSelector = ".header__search-results";
const $searchField = $(".header__search input.search__field");
var isAjax = false;

$(document).ready(function () {
	const $searchInput = $(".header__search input");
	const $searchBarParent = $(".search-bar-parent");
	const $newSearchBar = $("#new-searchbar");
	const $searchResults = $(".search-results-items"); // This is where results are injected
	const $body = $("body");

	let isAjax = false;

	$(".search__btn").on("click", function (e) {
		e.preventDefault();
		return false;
	});

	$searchInput.on("click", function (event) {
		event.stopPropagation();
		$searchBarParent.removeClass("hidden");
		$("#new-searchbar").focus();
	});

	$(document).on("click", function (event) {
		if (
			!$newSearchBar.is(event.target) &&
			$newSearchBar.has(event.target).length === 0 &&
			!$newSearchBar.is(event.target)
		) {
			$searchBarParent.addClass("hidden");
			$body.removeClass("overflow-hidden");
		}
	});

	$(document).on("keydown", function (event) {
		if (event.key === "Escape") {
			$searchBarParent.addClass("hidden");
			$body.removeClass("overflow-hidden");
		}
	});

	// Perform AJAX search on input
	$searchInput.on(
		"input",
		debounce(function () {
			const query = $(this).val().trim(); // Added trim() to remove accidental spaces

			if (query === "") {
				$searchResults.addClass("hidden");
				return; // Exit if the query is empty
			}

			$body.addClass("overflow-hidden");

			// Prevent multiple concurrent AJAX requests
			if (isAjax) return;

			isAjax = true; // Set isAjax immediately

			const settings = {
				url: resources.ajax, // Update this with your actual AJAX URL
				method: "GET",
				data: {
					action: "app_search",
					search: query,
					limit: 10,
				},
				beforeSend: function () {
					console.log("Before sending the request for:", query);
					console.log("Show spinner");
				},
			};

			$.ajax(settings)
				.done(function (response) {
					// Check if the response is empty or no results
					if (
						!response.data ||
						!response.data.search ||
						response.data.search.length === 0
					) {
						// If no results, show a 'no results' message
						$searchResults.removeClass("hidden");
						$searchResults.html(
							"<div class='no-results'>Geen resultaten gevonden</div>"
						);
					} else {
						// If there are results, show them
						$searchResults.removeClass("hidden");

						if (response.data.search && response.data.search.length > 0) {
							// If results, show them
							$searchResults.removeClass("hidden");
							$searchResults.html(response.data.search);
						} else {
							// If no results, show 'no results' message
							$searchResults.removeClass("hidden");
							$searchResults.html(
								"<div class='no-results'>Geen resultaten gevonden</div>"
							);
						}
					}
				})
				.fail(function (error) {
					console.log("Error:", error);
					$searchResults.addClass("hidden");
				})
				.always(function () {
					// Reset isAjax regardless of success or failure
					isAjax = false;
				});
		}, 300) // Increased debounce time to 300ms
	);
});
